import {Component, ElementRef, inject, OnInit, signal, ViewEncapsulation} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {ActivatedRoute} from '@angular/router';
import {authCodeFlowConfig} from '../../config/auth-code-flow.config';
import {FormsModule} from '@angular/forms';
import {AuthService} from '../../services/auth.service';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';
import {DatePipe} from '@angular/common';
import {GetStatRequest} from '../../services/models/GetStatRequest';
import {SearchService} from '../../services/search.service';
import {VerticalBarComponent} from '../../components/vertical-bar/vertical-bar.component';
import {ResumeDto} from '../../services/models/ResumeDto';
import {SharedModule} from '../../components/shared.module';
import {NumberFormatPipe} from '../../pipes/number-format-pipe';
import {TokenService} from '../../services/token.service';
import {
  GroupedVerticalBarChartComponent
} from '../../components/grouped-vertical-bar-chart/grouped-vertical-bar-chart.component';

@Component({
  selector: 'antm-home',
  imports: [
    FormsModule,
    MatCard,
    MatCardTitle,
    MatCardContent,
    VerticalBarComponent,
    SharedModule,
    NumberFormatPipe,
    MatCardHeader,
    GroupedVerticalBarChartComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit {
  private elementRef = inject(ElementRef);
  width: number = 0;
  height: number = 0;
  login = false;
  resume = signal<ResumeDto | null>(null);
  data: any[];
  groupedData: any[];
  hideParcels: boolean = false;
  constructor(
    private _oauthService: OAuthService,
    private _authService: AuthService,
    private _route: ActivatedRoute,
    private _searchService: SearchService,
    public tokenService: TokenService
  ) {
    this.login = false;
  }

  ngOnInit() {
    this._route.params.subscribe((p) => {
      this.login = p['login'];
    });
    const startDate = new Date();
    const fifteenDaysAgo = new Date();
    fifteenDaysAgo.setDate(fifteenDaysAgo.getDate() - 15);
    const datePipe = new DatePipe('en');
    this._searchService.getCommands({
      startDate: fifteenDaysAgo,
      endDate: startDate
    } as GetStatRequest)
      .subscribe(data => {
        const groupedData = [];
        data.forEach((value, key) => {
          groupedData.push(
            {
              name: datePipe.transform(new Date(key), 'dd/MM/yyyy'),
              series: [
                {
                  name: "L'année dernière",
                  value: value.lastYearAmount || 0
                },
                {
                  name: "Cette année",
                  value: value.amount
                },
              ]
            }
          )
        })
        this.groupedData = groupedData;
      })
    this._searchService.getResume().subscribe(it => {
      this.resume.set(it);
    })

    this.hideParcels = !this.tokenService.hasRole('ADMIN');
    // This would directly (w/o user interaction) redirect the user to the
    // login page if they are not already logged in.
  }
  logout() {
    // this.oauthService.logOut();
    this._authService.logout();
    // sessionStorage.clear();
    // localStorage.clear();
    // this._oauthService.revokeTokenAndLogout();
  }
  async loginCode() {
    // Tweak config for code flow
    this._oauthService.configure(authCodeFlowConfig);
    this._oauthService.loadDiscoveryDocument().then((any) => {
      this._oauthService.initLoginFlow('/some-state;p1=1;p2=2?p3=3&p4=4');
    });
    // the parameter here is optional. It's passed around and can be used after logging in
  }

  get givenName() {
    var claims = this._oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['sub'];
  }

  get familyName() {
    var claims = this._oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['family_name'];
  }

  get useHashLocationStrategy() {
    return localStorage.getItem('useHashLocationStrategy') === 'true';
  }

  get id_token() {
    return this._oauthService.getIdToken();
  }

  get access_token() {
    return this._oauthService.getAccessToken();
  }

  get id_token_expiration() {
    return this._oauthService.getIdTokenExpiration();
  }

  get access_token_expiration() {
    return this._oauthService.getAccessTokenExpiration();
  }

  get hasValidAccessToken() {
    return this._oauthService.hasValidAccessToken();
  }

  get hasValidIdToken() {
    return this._oauthService.hasValidIdToken();
  }

  getDimensions() {
    const element = this.elementRef.nativeElement as HTMLElement;

    // ✅ Différentes façons de récupérer les dimensions

    // offsetWidth/Height: inclut padding + border
    this.width = element.offsetWidth;
    this.height = element.offsetHeight;

    // clientWidth/Height: inclut padding mais PAS border
    const clientWidth = element.clientWidth;
    const clientHeight = element.clientHeight;

    // scrollWidth/Height: taille totale incluant le contenu scrollable
    const scrollWidth = element.scrollWidth;
    const scrollHeight = element.scrollHeight;

    // getBoundingClientRect: dimensions exactes avec décimales
    const rect = element.getBoundingClientRect();
    const preciseWidth = rect.width;
    const preciseHeight = rect.height;

    console.log('Dimensions complètes:', {
      offset: {width: this.width, height: this.height},
      client: {width: clientWidth, height: clientHeight},
      scroll: {width: scrollWidth, height: scrollHeight},
      rect: {width: preciseWidth, height: preciseHeight}
    });
  }
}
